<section class="gallery {{type}} {{companyId}} {{section}} {{galleryId}}" *ngIf="!noItems" [class.unika-gal]="unika">
    <div *ngIf="this.type === 'mosaic'" class="elliptical-button" (mouseenter)="startScroll('left')" (mouseleave)="stopScroll()">
        <div class="arrow"></div>
        <div class="arrow"></div>
        <div class="arrow"></div>
      </div>
   
    <div *ngIf="intro" class="intro">
        <b [innerHtml]="intro.content|safe :'html'"></b>
    </div>

    <div class="thumbs-holder" [class.active]="thisShowScrollThumbs">
        <span class="thumbs-trigger" (click)="thisShowScrollThumbs = !thisShowScrollThumbs"></span>

        <ul class="thumbs scroll-container" #scrollContainer [ngClass]="{'big-images':!showThumbs}">
            <li *ngFor="let img of images; let i=index;" [attr.data-index]="i" class="image te---st {{ this.proportionsClass }}"  #parentImageRef>
                <!-- <img #imageRef (load)="checkImageOrientation(i, $event, parentImageRef)" [@slideRight] [src]="img.thumb" (click)="showPreview(0,'image',i)" /> -->
                <img #imageRef (load)="checkImageOrientation(i, $event, parentImageRef)" [@slideRight] [src]="img.thumb" (mousedown)="onMouseDown($event, i)" />
                <div class="title">
                    <!-- <a (click)="download(img)" download="" class="download"><i class="icon-download"></i></a> -->
                    <span>{{img.title}}</span>
                </div>
            </li>

            <li *ngFor="let clip of youtubes; let i=index" class="youtube">
                <img [src]="clip.thumb" (click)="showPreview(0,'youtube',i)" />
                <div class="title">
                    <span>{{clip.title}}</span>
                </div>
            </li>

            <!-- <li @slideRight *ngFor="let doc of documents; let i=index" class="document"> -->
            <li *ngFor="let doc of documents; let i=index" class="document">
                <a [href]="doc.path">
                    <img [src]="doc.thumb" />
                    <span>{{doc.title}}</span>
                    <i class="icon-download"></i>
                </a>
            </li>

            <li *ngFor="let doc of pdfs | rankingNum: 'count'; let i=index" class="document"
                [ngStyle]="{ order: doc.count }">
                <a (click)="showPreview(0,'pdf',i)">
                    <img [src]="doc.thumb" />
                    <span>{{doc.title}}</span>
                    <!-- <span>{{doc.count}}</span> -->
                </a>
            </li>

        </ul>
    </div>

    <ul>
        <li *ngFor="let iframe of iframes; let i=index" class="iframes">
            <div [innerHtml]="iframe.html|safe :'html'"></div>
        </li>

        <li *ngFor="let html of htmls; let i=index" class="htmls">
            <div [innerHtml]="html.content|safe :'html'"></div>
        </li>
    </ul>


    <div *ngIf="preview.show" class="preview" [class.active-mosaic]="showMosaicPreview">
        <a class="pClose" (click)="closePreview()"><i class="icon-close"></i></a>
        <a *ngIf="preview.showNext" class="pNext" (click)="showPreview(1)"><i class="icon-arrow-left"></i></a>
        <a *ngIf="preview.showPrevious" class="pPrevious" (click)="showPreview(-1)"><i class="icon-arrow-right"></i></a>
        <!-- <a *ngIf="preview.type=='image'" href="javascript:;" id="downloadLink" (click)="download()"  download><i class="icon-download"></i></a> 
         <a href="#{{this.preview.path}}?alt=media" class="downloadMe"  id="downloadMe" download="Image.jpg" (click)='forceDownload()'>Download Image</a>  -->

        <!-- <div *ngIf="this.illustrationOnly" class="illustration-only">{{ 'ILLUSTRATION-ONLY' |
            translate }}</div> -->
        <div *ngIf="this.illustrationOnly" class="illustration-only"><span
                *ngIf="!this.illustrationOnlyNote || this.resolution < 1200">{{ 'ILLUSTRATION-ONLY' | translate
                }}</span>
            <span class="illustration-only-note" *ngIf="this.illustrationOnlyNote">{{ this.illustrationOnlyNote |
                translate }}</span>
        </div>
        
        <div class="gal-content">
            <h4>{{ preview.title }}</h4>
            <div [class.draggable-holder]="resizeDrag" class="">
                <div *ngIf="resizeDrag" class="draggable1">
                    <div>
                        <!-- <div class="preview-img" [innerHtml]="preview.html|safe :'html'"></div> -->
                        <div [@changeDivSize]="preview.index" class="preview-img">
                            <ng-container *ngFor="let img of images; let i=index">
                                <!-- <img [src]="this.urldd" *ngIf="i===preview.index" id="test1" (mousedown)="addDragListener()" /> -->
                                <ng-container *ngIf="resolution < 1200">
                                    <pinch-zoom>
                                        <img [src]="this.urldd" id="drag-element" />
                                    </pinch-zoom>
                                </ng-container>
                                <ng-container *ngIf="resolution > 1200">
                                    <pinch-zoom>
                                        <img [src]="this.urldd" id="drag-element" />
                                    </pinch-zoom>
                                </ng-container> 
                            </ng-container>
                            <ng-container *ngFor="let img of youtubes; let i=index">
                                <div class="preview-img" [innerHtml]="preview.html|safe :'html'"
                                    *ngIf="i===preview.index"></div>
                            </ng-container>
                            <ng-container *ngFor="let img of pdfs; let i=index">
                                <div class="preview-img" [innerHtml]="preview.html|safe :'html'"
                                    *ngIf="i===preview.index"></div>
                            </ng-container>
                        </div>
                    </div>
                </div>
                <div *ngIf="!resizeDrag">
                    <div [@changeDivSize]="preview.index" class="galHolder">
                        <div class="loading" *ngIf="images.length === 0 &&  youtubes.length === 0 && pdfs.length === 0"><div class="loader"></div></div>
                        <ng-container *ngFor="let img of images; let i=index">
                            <img class="background-image" [src]="this.urldd" *ngIf="i===preview.index && img.type != 'svg'" />
                            <img [src]="this.urldd" *ngIf="i===preview.index && img.type != 'svg'" />
                            <app-svg-loader *ngIf="img.type == 'svg'" [svgUrl]="this.urldd"></app-svg-loader>
                        </ng-container>
                        <ng-container *ngFor="let img of youtubes; let i=index">
                            <div class="preview-img" [innerHtml]="preview.html|safe :'html'" *ngIf="i===preview.index">
                            </div>
                        </ng-container>
                        <ng-container *ngFor="let img of pdfs; let i=index">
                            <div class="preview-img" [innerHtml]="preview.html|safe :'html'" *ngIf="i===preview.index">
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <!-- <ul class="resize-buttons" [class.hidden]="!resizeDrag">
            <li class="plus" (click)="changeImageSize('plus')"><span>+</span></li>
            <li class="minus" (click)="changeImageSize('minus')"><span>-</span></li>
        </ul> -->
    </div>


    <div class="hidden"><canvas id="canvasDownload"></canvas><img id="imgDownload" /></div>
</section>
